import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// แถบบนสุด: สถานะผู้ใช้ + เมนูลัดบัญชี
export default function TopBar({ profile, onLogout }) {
  const [openUser, setOpenUser] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpenUser(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  return (
    <div className="lt-topbar">
      <div className="lucid-container lt-topbar__inner">
        <div className="lt-topbar__wallet">
          <span>เติมเกมออนไลน์ · เติมเงินมือถือ · บัตรเติมเงิน ตลอด 24 ชม.</span>
        </div>

        <div className="lt-topbar__user" ref={wrapRef} style={{ position: "relative" }}>
          {!profile ? (
            <div className="lt-topbar__guest">
              <Link to="/login">🔒 เข้าสู่ระบบ</Link>
              <span>|</span>
              <Link to="/register">👤 สมัครสมาชิก</Link>
            </div>
          ) : (
            <>
              <button
                type="button"
                onClick={() => setOpenUser((v) => !v)}
                style={{ border: "none", background: "none", display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}
              >
                <span className="lt-avatar">
                  {profile.avatar ? <img src={profile.avatar} alt="" /> : (profile.fullname || profile.email || "L").charAt(0).toUpperCase()}
                </span>
                <span>{profile.fullname || profile.email}</span>
              </button>

              {openUser ? (
                <div className="lt-nav__dropdown" style={{ top: 42, left: "auto", right: 0 }}>
                  <Link to="/profile">ตั้งค่าสมาชิก</Link>
                  <Link to="/profile/topup-game-history">ประวัติการเติมเกม</Link>
                  <Link to="/profile/address">ที่อยู่จัดส่ง</Link>
                  <button
                    type="button"
                    onClick={onLogout}
                    style={{
                      display: "block",
                      width: "100%",
                      textAlign: "left",
                      border: "none",
                      background: "none",
                      padding: "9px 12px",
                      color: "var(--lt-red)",
                      cursor: "pointer",
                    }}
                  >
                    ออกจากระบบ
                  </button>
                </div>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
